/**
 * Desktop - Cart management.
 */

// Imports
import GlobalVars from '../common/GlobalVars';
import AjaxURL from '../common/AjaxURL';
import {
  triggerCartUpdateEvent,
  cartItemAddedEventName,
  cartItemRemovedEventName,
} from '../common/Events';
import {
  init as initialInit,
  getItemsCount,
  getItemIndex,
  hasItems,
  updateSkusList,
  returnSkusList,
  addItem,
  addItems,
  removeItem,
} from '../common/Cart';

/**
 * Sends a request to the server to get up-to-date cart items.
 * @param {Function} [aoCallback] - Callback function with one or two arguments:
 * - boolean: whether the request succeeded or not
 * - object: root element for the HTML response in case of success
 */
function updateCart(aoCallback) {
  $.ajax({
    url: AjaxURL.getbag,
    data: {
      task: 'getbaghtml',
      c: GlobalVars.C,
      l: GlobalVars.L
    },
    dataType: 'html',
    type: 'post',
  }).done((asResponse) => {
    const $htmlElements = $($.trim(asResponse));
    if (typeof aoCallback === 'function') {
      // Call the given callback
      aoCallback(true, $htmlElements);
    }

    // Trigger the cart update event
    triggerCartUpdateEvent(true, $htmlElements);
  }).fail(() => {
    if (typeof aoCallback === 'function') {
      // Call the given callback
      aoCallback(false);
    }

    // Trigger the cart update event
    triggerCartUpdateEvent(false);
  });
}

function init() {
  initialInit();

  $(document).on([
    cartItemAddedEventName,
    cartItemRemovedEventName,
  ].join(' '), () => {
    // Send AJAX request to get the updated HTML
    updateCart();
  });
}

// Named exports - Functions
export {
  init,
  getItemsCount,
  getItemIndex,
  hasItems,
  updateSkusList,
  updateCart,
  addItem,
  addItems,
  removeItem,
  returnSkusList,
};



// WEBPACK FOOTER //
// ./js/desktop/Cart.js